<template>
    <main>
        <page-header-compact>
            Configuración de Formularios
        </page-header-compact>
        <div class="container-fluid px-4">
            <div class="card mt-4">
                <div class="card-body">
                    <data-grid :data="pagination"
                           @changePage="changePage($event)"
                           @perPageChange="perPageChange($event)"
                           @search="search($event)">
                            <template #grid>
                                <grid-table>
                                    <template #head>
                                        <grid-cell-header class="bg-light"  v-for="(h,i) in headers" :key="`h_${i}`">{{h}}</grid-cell-header>
                                    </template>
                                    <template #body>
                                        <grid-row v-for="(item, i) in pagination.data" :key="`d_${i}`">
                                            <grid-cell class="text-center small">
                                                {{item.codigo}}
                                            </grid-cell>
                                            <grid-cell class="text-center small">
                                                {{item.nombre}}
                                            </grid-cell>
                                            <grid-cell class="text-center ">
                                                <h1 v-if="item.activo=='N'" class="badge badge-danger">Inactivo</h1>
                                                <h1 v-else class="badge badge-success">Activo</h1>
                                            </grid-cell>
                                            <grid-cell class="text-center   ">
                                                <button class="btn btn-outline-info btn-xs mx-2" type="button" @click="abrirModal(item.id)"  >
                                                      <i class="fas fa-edit fa-fw" ></i> Editar
                                                </button>
                                                <button class="btn btn-outline-primary btn-xs" type="button" @click="secciones(item.id)"  >
                                                    <i class="fas fa-angle-right fa-fw"></i> Secciones 
                                                </button>
                                            </grid-cell>
                                        </grid-row>
                                    </template>
                                </grid-table>
                            </template>
                        <template #action-button>
                            <button  class="btn btn-info btn-sm shadow-sm mb-2" type="button" data-toggle="modal" data-target="#modalFormularios">
                                Nuevo &nbsp;<i class="fas fa-plus"></i>
                            </button>
                        </template>
                    </data-grid>
                </div>
            </div>
            <modalFormularios ref="modalFormularios" v-on:cargar-formularios="getFormularios"></modalFormularios>
        </div>
    </main>
</template>
<script>
import PageHeaderCompact from "../../../../components/layouts/content/page-header-compact";
import modalFormularios from "./modalFormularios";
import formulariosService from "../../../../services/formulariosService";

import DataGrid from "../../../../components/common/utilities/DataGrid/DataGrid";
import GridTable from "../../../../components/common/utilities/DataGrid/GridTable";
import GridCellHeader from "../../../../components/common/utilities/DataGrid/GridCellHeader";
import GridRow from "../../../../components/common/utilities/DataGrid/GridRow";
import GridCell from "../../../../components/common/utilities/DataGrid/GridCell";
import Toast from '../../../../components/common/utilities/toast';

export default {
    components: {
        modalFormularios,
        PageHeaderCompact,GridCell, GridRow, GridCellHeader, GridTable, DataGrid
    },

    data() {
        return {
            formularioss:{},
            headers : [
               'Codigo',
               'Nombre',
               'Estado',
               'Opciones'
           ],
           pagination : {
               data : [],
               current_page : 1,
               page : 1,
               per_page : 5,
               search : '',
               total: '',
           }
        }
    },
    methods : {
        async getFormularios(){
            try {
                this.LoaderSpinnerShow();
                const response = (await formulariosService.index(this.pagination.search, this.pagination))?.data;
                this.formularioss = response.data;
                this.pagination.data = response.data;
                this.pagination.current_page  = response.current_page;
                this.pagination.total = response.total;
                this.LoaderSpinnerHide();
            }catch (e) {
                console.error(e);
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
        },
        changePage(page) {
            this.pagination.page = page;
            this.getFormularios();
        },
        perPageChange(per_page) {
            this.pagination.per_page = per_page;
            this.pagination.page = 1;
            this.getFormularios();
        },
        search(query){
            this.pagination.search = query;
            this.pagination.page = 1;
            this.getFormularios();
        },
        abrirModal(id){
           this.$refs.modalFormularios.edit(id);
        },
        secciones(id){
            this.$router.push({
                name: 'secciones.formulario',
                params: { id: id }
            });
        }
    },
    async created() {
       await this.getFormularios();
    }

}
</script>
